export enum ChinaCompetitionResultOrderByColumn {
  AGENT = "AGENT",
  RANKING = "RANKING",
  BATCH_POINTS = "BATCH_POINTS",
  NN_POINTS = "NN_POINTS",
  KOOP_POINTS = "KOOP_POINTS",
  IAD_REALTY_POINTS = "IAD_REALTY_POINTS",
  IAD_IPLUS_POINTS = "IAD_IPLUS_POINTS",
  IBIS_POINTS = "IBIS_POINTS",
  TOTAL_PARTNER_POINTS = "TOTAL_PARTNER_POINTS",
  EDUCATION_POINTS = "EDUCATION_POINTS",
  BROKER_POINTS = "BROKER_POINTS",
  CANCELLATION_POINTS = "CANCELLATION_POINTS",
  TOTAL_POINTS = "TOTAL_POINTS",
}

export enum SloveniaCompetitionResultOrderByColumn {
  AGENT = "AGENT",
  RANKING = "RANKING",
  NN_POINTS = "NN_POINTS",
  KOOP_POINTS = "KOOP_POINTS",
  IAD_REALTY_POINTS = "IAD_REALTY_POINTS",
  IAD_IPLUS_POINTS = "IAD_IPLUS_POINTS",
  CLIENT_POINTS = "CLIENT_POINTS",
  CANCELLATION_POINTS = "CANCELLATION_POINTS",
  TOTAL_POINTS = "TOTAL_POINTS",
}
